import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../store/authStore';
import { LoadingSpinner } from '../ui';
import { AccessDenied } from '../../pages/AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

interface AdminRouteProps {
  children: React.ReactNode;
  pageName?: string;
  requiredPermission?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <LoadingSpinner />
          <p className="mt-4 text-muted-foreground">인증 상태를 확인하는 중...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// 관리자 전용 라우트 컴포넌트
const AdminRoute: React.FC<AdminRouteProps> = ({
  children,
  pageName = '이 페이지',
  requiredPermission = '관리자 권한'
}) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <LoadingSpinner />
          <p className="mt-4 text-muted-foreground">인증 상태를 확인하는 중...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <AccessDenied
        pageName={pageName}
        requiredPermission={requiredPermission}
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
export { AdminRoute };